<div *ngIf="terminalMode" class="menu-item-container">
    <bb-menu-item-image [menuItem]="item.menuItem"
                        [showInventory]="showInventory"
                        [screenWidth]="screenWidth"></bb-menu-item-image>

    <div *ngIf="terminalMode && screenWidth > Constants.SMALL_MENU_SIZE"
         class="menu-item-info-container">
        <div class="menu-item-name">
            <span *ngIf="!!item.menuItem.imageAddress && showImages">{{ item.menuItem.name }}</span>
        </div>
        <div *ngIf="!!item.menuItem.defaultPrice || !!this.minToken" [class.menu-item-price-alone]="!item.menuItem.imageAddress"
             class="menu-item-price">
            <span *ngIf="!!item.menuItem.defaultPrice && !this.minToken">{{ item.menuItem.defaultPrice.price | currency }}</span>
            <div class="token-information-container" *ngIf="!!this.minToken">
                <span class="token-count" *ngIf="this.minToken != this.maxToken">{{ this.minToken }} - {{ this.maxToken }}</span>
                <span class="token-count" *ngIf="this.minToken === this.maxToken">{{ this.minToken }}</span>
                <ion-icon src="assets/icon/token.svg"></ion-icon>
            </div>
        </div>
    </div>

    <div *ngIf="!!item.menuItem.flavorText && showImages && !!item.menuItem.imageAddress && screenWidth >= Constants.SMALL_MENU_SIZE"
         class="menu-item-flavor-text">
        {{ item.menuItem.flavorText }}
    </div>

    <div *ngIf="!terminalMode && exactInventory && !!exactInventory.mobileCountdownStart && exactInventory.currentCount <= exactInventory.mobileCountdownStart"
         class="mobile-countdown">
        {{ exactInventory.currentCount }} remaining
    </div>
</div>

<div *ngIf="!terminalMode" class="mobile-menu-item-container">
    <div class="mobile-menu-item-information">
        <h3 class="mobile-menu-item-information-title">{{ item.name }}</h3>
        <p *ngIf="!!item.menuItem && !!item.menuItem.flavorText" class="mobile-menu-item-information-flavor-text">{{ item.menuItem.flavorText }}</p>
        <p *ngIf="!!item.menuItem && !!item.menuItem.description" class="mobile-menu-item-information-description">{{ item.menuItem.description }}</p>

        <div *ngIf="!!menuItemPrice || !!item.menuItem.defaultPrice || !!this.minToken" class="mobile-menu-item-information-price">
            <span *ngIf="!item.menuItem.defaultPrice && !!menuItemPrice && !this.minToken"
                  class="price-name">{{ menuItemPrice.price | currency }}</span>
            <span *ngIf="!!item.menuItem.defaultPrice && !!item.menuItem.defaultPrice.name && item.menuItem.defaultPrice.name !== 'Default' && !this.minToken"
                  class="price-name">{{ item.menuItem.defaultPrice.name }}</span>
            <span *ngIf="!!item.menuItem.defaultPrice && !this.minToken">{{ item.menuItem.defaultPrice.price | currency }}</span>
            <div class="token-information-container" *ngIf="!!this.minToken">
                <span class="token-count" *ngIf="this.minToken != this.maxToken">{{ this.minToken }} - {{ this.maxToken }}</span>
                <span class="token-count" *ngIf="this.minToken === this.maxToken">{{ this.minToken }}</span>
                <ion-icon src="assets/icon/token.svg"></ion-icon>
            </div>
        </div>

        <div *ngIf="!terminalMode && exactInventory && !!exactInventory.mobileCountdownStart && exactInventory.currentCount <= exactInventory.mobileCountdownStart"
             class="mobile-countdown">
            {{ exactInventory.currentCount }} remaining
        </div>
    </div>
    <div *ngIf="!!item.menuItem && !!item.menuItem.imageAddress && !organization.hideMobileImages" class="mobile-menu-item-image">
        <bb-menu-item-image [menuItem]="item.menuItem"
                            [orderDisplay]="true"
                            [showInventory]="false"
                            [screenWidth]="screenWidth"></bb-menu-item-image>
    </div>
</div>
